import React from 'react';
import { shape, string } from 'prop-types';
import { Container, Grid } from '@material-ui/core';
import SingleCasePage from '../../templates/SingleCasePage';
import data from '../../data/cases/detecht';
import nextCaseData from '../../data/casesThumb/installationspartner';
import InfoColumnSection from '../../components/InfoColumnSection';
import TitleAndBodySection from '../../components/case/TitleAndBodySection';
import ContainerNoFrame from '../../components/case/ContainerNoFrame';
import SingleImage from '../../components/case/SingleImage';
import DoubbleImage from '../../components/case/DoubleImage';
import variables from '../../styles/variables.module.scss';

const nextCase = {
  title: nextCaseData.title,
  path: nextCaseData.path,
  casebg: nextCaseData.casebg,
  color: nextCaseData.color,
  isWeb: nextCaseData.isWeb,
};

const DetechtCasePage = ({ location }) => (
  <SingleCasePage
    location={location}
    caseName={data.key}
    data={data}
    nextCase={nextCase}
    quoteData={data.quoteData}
    alignHeroImage="center"
  >
    <Container>
      <Grid container direction="column">
        {
          data.titleBodyData[0] && (
            <TitleAndBodySection
              title={data.titleBodyData[0].title}
              body={data.titleBodyData[0].body}
              justify={data.titleBodyData[1] ? 'flex-end' : 'flex-start'}
            />
          )
        }
      </Grid>
    </Container>
    {
      data.environments && (
      <DoubbleImage
        imageLeft={data.environments.env1}
        imageRight={data.environments.env2}
      />
      )
    }
    {
      data.titleBodyData[1] && (
        <TitleAndBodySection
          title={data.titleBodyData[1].title}
          body={data.titleBodyData[1].body}
        />
      )
    }
    {
      data.xtra && (
        <ContainerNoFrame
          images={data.xtra}
          style={{ marginTop: '80px' }}
          imagePadding
        />
      )
    }
    {
      data.infoTitle && data.infoBody && (
        <Grid item>
          <InfoColumnSection
            headlineSmall={data.title}
            backgroundColor={variables.carbonBlack}
            title={data.infoTitle}
            body={data.infoBody}
            isCase
          />
        </Grid>
      )
    }
    {
      data.footerBanner && (
        <SingleImage
          image={data.footerBanner}
          isAndroid={data.isAndroid}
          insideGrid={data.footerBanner.insideGrid}
          style={{ width: '100%', margin: 0 }}
        />
      )
    }
  </SingleCasePage>
);

DetechtCasePage.propTypes = {
  location: shape({
    pathname: string,
  }).isRequired,
};

export default DetechtCasePage;
